var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbsBox',{staticClass:"d-flex p-3 bg-info text-light font-weight light"},[_c('h1',{staticClass:"m-auto"},[_c('Icon',{staticClass:"mr-2",attrs:{"name":"mdi.information"}}),_vm._v(" Cognitive Test has been deprecated. ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }